import { MessageCircle } from "lucide-react";
import { WA_LINK } from "../lib/constants";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={WA_LINK()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#00B37E]/40 animate-ping group-hover:hidden" />
      <span className="relative flex items-center gap-2 px-4 py-3 rounded-full bg-[#00B37E] hover:bg-[#009166] text-white font-semibold shadow-2xl shadow-[#00B37E]/40 transition-all hover:scale-105">
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline text-sm">Chat with us</span>
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
